<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>

import { getUserTagList, removeUserTag } from '@/api/demo/user'
import { fileTagList, removeFileTag } from '@/api/demo/file'

export default {
  name: 'fileTag',
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      keywordList: [],
      form: {
        color: '', // 名称
        word: '' // 标签
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '标签',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path === '/demo/file/tag' && from.path === '/demo/file/tag/edit') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  methods: {
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      fileTagList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.$router.push({
        path: '/demo/file/tag/edit'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/file/tag/edit?id=' + id
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeFileTag(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
